import React from "react";
import { connect } from "react-redux";
import CookieConsent from "../Components/CookieConsent";

const CookieConsentContainer = props => <CookieConsent {...props} />;

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CookieConsentContainer);
